import { reactive, computed, onMounted, watch } from '@vue/composition-api'
import useRouter from '../useRouter'

const useTabsButtons = () => {
    const { route, router } = useRouter()
    const currentRoute = {...route.value}
    const state = reactive({
        tabs: [
            {
                name: 'requests',
                buttons: [
                    {
                        title: 'Received Requests',
                        active: false,
                        type: 'received',
                        id: 'received-requests'
                    },
                    {
                        title: 'Sent Requests',
                        active: false,
                        type: 'sent',
                        id: 'sent-requests'
                    },
                ],
            },
            {
                name: 'updates',
                buttons: [
                    {
                        title: 'Scheduled Updates',
                        active: false,
                        type: 'scheduled',
                        id: 'scheduled-updates'
                    },
                    {
                        title: 'Unscheduled Updates',
                        active: false,
                        type: 'unscheduled',
                        id: 'unscheduled-updates'
                    },
                ],
            }
        ]
    })

    const currentTabButtons = computed(() => {
        const currentTab = state.tabs.find(el => el.name === route.value.name)
        return currentTab && currentTab.buttons;
    })

    const setTab = (index, onload) => {
        currentTabButtons.value[index].active = true;
        currentTabButtons.value[Number(!index)].active = false;

        if(!onload) {
            router.replace({
                query: {
                    ...route.value.query,
                    filters: undefined
                }
            }).catch(() => {})
        }
            
    }

    onMounted(() => {
        if(route.value.query.type){
            currentTabButtons.value.find(item => item.type === route.value.query.type).active = true;
        } else {
            setTab(0,true);
        }
    })

    return {
        currentTabButtons,
        setTab
    }
}

export default useTabsButtons